<template>
  <div class="email-otp-verification">
    <div class="email-otp-verification__actions">
      <div class="email-otp-verification__otp">
        <div class="email-otp-verification__content">
          <h3 class="email-otp-verification__content__title">Подтвердите e-mail</h3>
          <p class="email-otp-verification__content__description">
            На указанную почту был отправлен код для подтверждения.
          </p>
        </div>

        <otp-input @change="setCode" />
      </div>

      <primary-button
        :loading="verifyCodeLoading"
        :disabled="!isValidCode"
        @click="$emit('verify')"
      >
        Отправить
      </primary-button>

      <text-button
        :loading="sendVerificationCodeLoading"
        :disabled="!isCodeExpired"
        @click="retryVerificationCode"
      >
        Отправить код повторно
      </text-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import OtpInput from '@/components/OtpInput.vue'
import PrimaryButton from '../PrimaryButton.vue'
import TextButton from '../TextButton.vue'

export default {
  components: {
    OtpInput,
    PrimaryButton,
    TextButton,
  },

  computed: {
    ...mapState('emailVerification', [
      'isValidCode',
      'verifyCodeLoading',
      'sendVerificationCodeLoading',
    ]),
    ...mapGetters('emailVerification', ['isCodeExpired']),
  },

  methods: {
    ...mapActions('emailVerification', ['retryVerificationCode']),
    ...mapMutations('emailVerification', ['setCode']),
  },
}
</script>
<style lang="scss">
$primary: #1b559e;

.email-otp-verification {
  &__otp {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &__title {
      font-weight: 700;
      font-style: Bold;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0%;

      color: $primary;

      padding: 0;
      margin: 0;
    }

    &__description {
      font-weight: 400;
      font-style: Regular;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;

      color: #838a99;

      padding: 0;
      margin: 0;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
}
</style>
